module.exports = __webpack_public_path__ + "static/media/example_2.c24d3011.png";